import { SubNavigation, SubNavigationLink } from "@apex/component-library";
import { Link as RouterLink, useLocation } from "react-router-dom";

import { usePermissions } from "../../contexts/permissions";
import { hasRequiredPermissions } from "../../hoc/withPermissions/helpers/hasRequiredPermissions";
import { Permissions } from "../../permissions";
import { AppRoutes } from "../../routes";

const SubNav = () => {
  const location = useLocation();
  const callsAndAlertsPath = `/${AppRoutes.CallsAlerts}`;
  const createCallPath = `/${AppRoutes.CreateCall}`;
  const exportPath = `/${AppRoutes.Export}`;

  const marginAccountDetails = `/${AppRoutes.MarginAccountDetails}`;

  const { permissions } = usePermissions();
  const canViewCallsAndAlerts = hasRequiredPermissions(permissions, [
    Permissions.AccountRead,
    Permissions.MarginProcessingUiNavView,
  ]);
  const canViewCreateCall = hasRequiredPermissions(permissions, [
    Permissions.MarginReportsModify,
    Permissions.AccountRead,
    Permissions.MarginProcessingUiNavView,
  ]);
  const canViewExport = hasRequiredPermissions(permissions, [
    Permissions.AccountRead,
    Permissions.MarginProcessingUiNavView,
  ]);
  const canViewRequirements = hasRequiredPermissions(permissions, [
    Permissions.AccountRead,
    Permissions.MarginProcessingUiNavView,
  ]);
  return (
    <SubNavigation>
      {canViewCallsAndAlerts && (
        <SubNavigationLink
          as={RouterLink}
          to={callsAndAlertsPath}
          isCurrentPage={location.pathname === callsAndAlertsPath}
          data-testid="calls-alerts-subnav"
        >
          Calls & Alerts
        </SubNavigationLink>
      )}
      {canViewCreateCall && (
        <SubNavigationLink
          as={RouterLink}
          to={createCallPath}
          isCurrentPage={location.pathname === createCallPath}
        >
          Create Call
        </SubNavigationLink>
      )}
      {canViewRequirements && (
        <SubNavigationLink
          as={RouterLink}
          to={marginAccountDetails}
          isCurrentPage={location.pathname.includes(marginAccountDetails)}
        >
          Margin Account Details
        </SubNavigationLink>
      )}
      {canViewExport && (
        <SubNavigationLink
          as={RouterLink}
          to={exportPath}
          isCurrentPage={location.pathname === exportPath}
        >
          Export Tool
        </SubNavigationLink>
      )}
    </SubNavigation>
  );
};

export default SubNav;
